<template>
  <div>
    <div class="flex relative mx-auto py-32" style="max-width: 1280px">
      <CompAccountSideMenu
        v-if="$route.meta.isInfo"
        :active="'account'"
      ></CompAccountSideMenu>
      <CompAccountSideMenu
        v-if="$route.meta.isPassword"
        :active="'password'"
      ></CompAccountSideMenu>
      <CompAccountSideMenu
        v-if="$route.meta.isSetting"
        :active="'settings'"
        :visible-section="state.visibleSection"
        @go-to-section="goToSection"
      ></CompAccountSideMenu>
      <section class="main-content" ref="mainContentRef">
        <div class="mb-4 py-2 text-2xl font-semibold leading-8 text-gray-92">
          <div v-if="$route.meta.isInfo">アカウント情報</div>
          <div v-if="$route.meta.isPassword">パスワード変更</div>
          <div v-if="$route.meta.isSetting">詳細設定</div>
        </div>
        <router-view></router-view>
      </section>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';
import CompAccountSideMenu from '@/views/account/vue/CompAccountSideMenu.vue';

export default {
  components: {
    CompAccountSideMenu,
  },
  setup() {
    const state = reactive({
      visibleSection: 'accountNotification',
    });
    const mainContentRef = ref(null);

    const goToSection = async (id) => {
      const target = document.getElementById(id);
      const scrollToPosition =
        target.offsetTop + target.parentNode.offsetTop - 80;
      if (target) {
        state.visibleSection = id;
        window.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth',
        });
      }
    };
    return {
      state,
      mainContentRef,
      goToSection,
    };
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  max-width: 920px;
  margin: 0 40px;
}
@media screen and (min-width: 1280px) {
  .main-content {
    margin: 0 40px 0 0;
  }
}
</style>
